import { useRef, useCallback } from 'react';

/**
 * Tracks in-flight async fetches so stale responses can be ignored when deps change mid-request.
 */
export function useFetchGeneration() {
  const genRef = useRef(0);

  const begin = useCallback(() => {
    genRef.current += 1;
    return genRef.current;
  }, []);

  const isCurrent = useCallback((gen) => gen === genRef.current, []);

  return { begin, isCurrent };
}
